// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__lP-WK","name":"Header_name__3SFbk","birthday":"Header_birthday__2SkRO","skeleton":"Header_skeleton__3ffCN"};